import React from "react";

/**
 * Reusable summary statistics component
 */
export default function SummaryStats({ stats }) {
  if (!stats) return null;

  const statItems = [
    {
      label: "Total Pedestrians",
      value: stats.totalPedestrians,
      color: "blue",
    },
    {
      label: "Total Vehicles",
      value: stats.totalVehicles,
      color: "green",
    },
    {
      label: "Total Cyclist",
      value: stats.totalCyclist,
      color: "red",
    },
    {
      label: "Total Count",
      value: stats.totalCount,
      color: "purple",
    },
    {
      label: "Avg Vehicles",
      value: stats.avgVehicles,
      color: "green",
      isAverage: true,
    },
    {
      label: "Records",
      value: stats.records,
      color: "gray",
    },
  ];

  const colorClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    purple: "text-purple-600",
    gray: "text-gray-700",
    red: "text-red-600"
  };

  const colorClassesLight = {
    blue: "text-blue-500",
    green: "text-green-500",
    purple: "text-purple-500",
    gray: "text-gray-700",
    red: "text-red-600"
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statItems.map((item, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-4">
          <p className="text-xs text-gray-500 mb-1">{item.label}</p>
          <p
            className={`${item.isAverage ? "text-xl" : "text-2xl"
              } font-${item.isAverage ? "semibold" : "bold"} ${item.isAverage
                ? colorClassesLight[item.color]
                : colorClasses[item.color]
              }`}
          >
            {typeof item.value === "number" && !item.isAverage
              ? item.value.toLocaleString()
              : item.value}
          </p>
        </div>
      ))}
    </div>
  );
}